module.exports = __webpack_public_path__ + "img/shortly-panda-assist-ai.9fe5096e.svg";